import { LocaleTagUtils } from "abweb/service/locale/LocaleTagUtils";
import { MethodType } from "abweb/service/rpc/MethodType";
export class LocaleService {
  constructor(rpcService, translatorManager) {
    this.rpcService = rpcService;
    this.translatorManager = translatorManager;
  }
  getSupportedLocales() {
    return this.rpcService.invokeRetJSON("/api/abweb/locale/supportedLocales", {}, MethodType.GET).then(localeTags => {
      return localeTags == null ? [] : localeTags.map(tag => {
        return LocaleTagUtils.normalizeLocaleTagForClient(tag);
      });
    });
  }
  setPreferredLocale(localeTag) {
    const params = localeTag ? {
      locale: localeTag
    } : null;
    return this.rpcService.invokeRetJSON("/api/abweb/locale/preferredLocale", params);
  }

  /**
   * @return asynchronously load module and override resource bundles into current i18n service
   */
  loadResourceBundles(modulePaths, moduleOverridesPaths) {
    return this.translatorManager.loadResourceBundles(modulePaths, moduleOverridesPaths);
  }
}
//# sourceMappingURL=LocaleService.js.map
